import {useState} from 'react';
import {Link, useLocation} from 'react-router';
import './Landing.css';

export default function Landing() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Carry the page the visitor was redirected from, so signing in returns them to it.
  const location = useLocation();

  return (
    <div className="lp-page">
      <header className="lp-nav">
        <div className="lp-nav-inner">
          <a className="lp-brand" aria-label="AIDentalBook home" href="#top">
            <img
              src="https://aidentalbook-poc.vercel.app/assets/logo-round.png"
              alt=""
              className="lp-brand-badge"
              width="34"
              height="34"
            />
            <span className="lp-brand-word">
              AI<span style={{color: '#1A1A2E'}}>Dental</span>Book
            </span>
          </a>
          <nav className="lp-nav-links" aria-label="Main">
            <a href="#top" className="lp-nav-link is-active" aria-current="page">
              Home
            </a>
            <a href="#about" className="lp-nav-link">
              About
            </a>
            <a href="#features" className="lp-nav-link">
              Features
            </a>
            <a href="#for-dentists" className="lp-nav-link">
              For Dentists
            </a>
            <a href="#for-patients" className="lp-nav-link">
              For Patients
            </a>
            <a href="#orthodontics" className="lp-nav-link">
              Orthodontics
            </a>
            <a href="#contact" className="lp-nav-link">
              Contact
            </a>
          </nav>
          <div className="lp-nav-actions">
            <Link className="lp-nav-signin" to="/login" state={location.state}>
              Sign In
            </Link>
            <button
              type="button"
              className="lp-burger"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span style={{transform: isMenuOpen ? 'translateY(6px) rotate(45deg)' : 'none'}}></span>
              <span style={{opacity: isMenuOpen ? '0' : '1'}}></span>
              <span style={{transform: isMenuOpen ? 'translateY(-6px) rotate(-45deg)' : 'none'}}></span>
            </button>
          </div>
        </div>
        {isMenuOpen && (
          <div className="lp-nav-sheet">
            <a href="#top" onClick={() => setIsMenuOpen(false)}>
              Home
            </a>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>
              About
            </a>
            <a href="#features" onClick={() => setIsMenuOpen(false)}>
              Features
            </a>
            <a href="#for-dentists" onClick={() => setIsMenuOpen(false)}>
              For Dentists
            </a>
            <a href="#for-patients" onClick={() => setIsMenuOpen(false)}>
              For Patients
            </a>
            <a href="#orthodontics" onClick={() => setIsMenuOpen(false)}>
              Orthodontics
            </a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)}>
              Contact
            </a>
            <Link className="lp-nav-sheet-cta" to="/login" state={location.state}>
              Sign In
            </Link>
          </div>
        )}
      </header>
      <main>
        <section id="top" className="lp-hero">
          <div className="lp-hero-wash" aria-hidden="true"></div>
          <div className="lp-hero-inner">
            <div className="lp-hero-copy">
              <h1 className="lp-hero-title">AIDentalBook</h1>
              <p className="lp-hero-sub">AI-Powered Digital Dental Care</p>
              <p className="lp-hero-body">
                Securely store, analyze and manage all your dental records in the cloud — for better care,
                together.
              </p>
              <div className="lp-hero-cta">
                <Link className="lp-btn-primary" to="/signup">
                  Get Started
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M5 12h13M12.5 6l6 6-6 6"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
            <div className="lp-hero-art">
              <div className="lp-hero-collage">
                <div className="lp-hero-plinth" aria-hidden="true">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="lp-hero-tooth">
                  <div
                    style={{overflow: 'hidden', borderRadius: '0', position: 'relative', aspectRatio: '0.78'}}
                  >
                    <img
                      src="https://aidentalbook-poc.vercel.app/assets/landing/hero-tooth.png"
                      alt="3D wireframe rendering of a molar"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>
                <div className="lp-float lp-float-xray">
                  <div
                    style={{
                      overflow: 'hidden',
                      borderRadius: '10px',
                      position: 'relative',
                      aspectRatio: '1.75',
                    }}
                  >
                    <img
                      src="https://aidentalbook-poc.vercel.app/assets/landing/hero-xray.jpg"
                      alt="Panoramic dental X-ray displayed on a tablet"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>
                <div className="lp-float lp-float-smile-a">
                  <div
                    style={{
                      overflow: 'hidden',
                      borderRadius: '10px',
                      position: 'relative',
                      aspectRatio: '1.15',
                    }}
                  >
                    <img
                      src="https://aidentalbook-poc.vercel.app/assets/landing/hero-smile-a.jpg"
                      alt=""
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center 40%',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>
                <div className="lp-float lp-float-smile-b">
                  <div
                    style={{
                      overflow: 'hidden',
                      borderRadius: '10px',
                      position: 'relative',
                      aspectRatio: '1.3',
                    }}
                  >
                    <img
                      src="https://aidentalbook-poc.vercel.app/assets/landing/hero-smile-b.jpg"
                      alt=""
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>
                <div className="lp-float lp-float-smile-c">
                  <div
                    style={{
                      overflow: 'hidden',
                      borderRadius: '10px',
                      position: 'relative',
                      aspectRatio: '1.15',
                    }}
                  >
                    <img
                      src="https://aidentalbook-poc.vercel.app/assets/landing/hero-smile-c.jpg"
                      alt=""
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: '32% center',
                        display: 'block',
                      }}
                    />
                  </div>
                </div>
              </div>
              <ul className="lp-cap-card">
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="4"
                      y="3"
                      width="16"
                      height="18"
                      rx="2.5"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></rect>
                    <path
                      d="M8 8h8M8 12h8M8 16h5"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Digital Records</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></circle>
                    <path
                      d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>AI Analysis</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2.8 20.5 7v10L12 21.2 3.5 17V7z"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M3.5 7 12 11.4 20.5 7M12 11.4v9.8"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>3D Models</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M8 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="m9 11.5 2 2 4-4"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M9 17h6"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Education</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="9"
                      cy="8"
                      r="3"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></circle>
                    <path
                      d="M3.5 19a5.5 5.5 0 0 1 11 0"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <circle
                      cx="17"
                      cy="9.5"
                      r="2.2"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></circle>
                    <path
                      d="M16 14.6a4.4 4.4 0 0 1 4.5 4.4"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>eMart</span>
                </li>
              </ul>
            </div>
          </div>
          <div
            className="lp-hero-fade"
            aria-hidden="true"
            style={{background: 'linear-gradient(180deg, #FFF0F5 0%, #FCF6FA 60%, #F5F2FF 100%)'}}
          ></div>
        </section>
        <section id="about" className="lp-section">
          <div className="lp-whatis">
            <div className="lp-whatis-copy">
              <h2 className="lp-whatis-title">What is AIDentalBook?</h2>
              <p className="lp-whatis-body">
                AIDentalBook is a cloud-based digital dental management platform that uses AI technology to
                store, analyze and organize your dental records. It helps patients, dentists and orthodontists
                achieve better oral health with greater accuracy and convenience.
              </p>
            </div>
            <ul className="lp-pillars">
              <li>
                <span className="lp-pillar-ico">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M7 18.5a4 4 0 0 1-.4-8 5.5 5.5 0 0 1 10.6-1.4A3.8 3.8 0 0 1 21 12.8a3.7 3.7 0 0 1-3.5 3.7"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M12 20.5v-7M9.4 15.6 12 13l2.6 2.6"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </span>
                <strong>Cloud-Based</strong>
                <span className="lp-pillar-sub">Secure &amp; Reliable</span>
              </li>
              <li>
                <span className="lp-pillar-ico">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="4.5"
                      y="10"
                      width="15"
                      height="10.5"
                      rx="2.5"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></rect>
                    <path
                      d="M8 10V7.5a4 4 0 0 1 8 0V10"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <circle
                      cx="12"
                      cy="15.2"
                      r="1.5"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></circle>
                  </svg>
                </span>
                <strong>HIPAA Compliant</strong>
                <span className="lp-pillar-sub">Your Data is Safe</span>
              </li>
              <li>
                <span className="lp-pillar-ico">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="2.5"
                      y="5"
                      width="13"
                      height="9.5"
                      rx="1.8"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></rect>
                    <path
                      d="M6 18h6"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <rect
                      x="16.5"
                      y="9"
                      width="5"
                      height="10"
                      rx="1.4"
                      stroke="#C43B71"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></rect>
                  </svg>
                </span>
                <strong>Anytime, Anywhere</strong>
                <span className="lp-pillar-sub">Access on All Devices</span>
              </li>
            </ul>
          </div>
        </section>
        <section id="features" className="lp-section">
          <div className="lp-head">
            <h2 className="lp-head-title">Key Features</h2>
            <div className="lp-head-sub">
              <span className="lp-rule" aria-hidden="true"></span>
              <span>Everything You Need for Smarter Dental Care</span>
              <span className="lp-rule" aria-hidden="true"></span>
            </div>
          </div>
          {/* Horizontally scrollable on narrow screens: focusable so keyboard users can scroll it. */}
          <ol className="lp-rail" tabIndex={0} aria-label="Key features">
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="7.5"
                    r="3.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <path
                    d="M4.5 20a7.5 7.5 0 0 1 15 0"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <strong>Patient</strong>
                <span>
                  <span>Dental Care</span>
                  <span>Needs</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="7"
                    y="2.5"
                    width="10"
                    height="19"
                    rx="2.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></rect>
                  <path
                    d="M10.8 5.4h2.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <strong>AIDentalBook</strong>
                <span>
                  <span>Dental Passport</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 18.5a4.2 4.2 0 0 1-.4-8.4 5.7 5.7 0 0 1 11-1.4A3.9 3.9 0 0 1 17.4 18.5z"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <strong>Cloud Storage</strong>
                <span>
                  <span>Secure Data</span>
                  <span>in the Cloud</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="6.5"
                    y="6.5"
                    width="11"
                    height="11"
                    rx="2"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></rect>
                  <path
                    d="M10 2.8v3.7M14 2.8v3.7M10 17.5v3.7M14 17.5v3.7M2.8 10h3.7M2.8 14h3.7M17.5 10h3.7M17.5 14h3.7"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <text
                    x="12"
                    y="14.4"
                    textAnchor="middle"
                    fontSize="6.4"
                    fontWeight="700"
                    fill="#C43B71"
                    fontFamily="var(--font-manrope), Manrope, system-ui"
                  >
                    AI
                  </text>
                </svg>
                <strong>AI Analysis</strong>
                <span>
                  <span>AI &amp; Data</span>
                  <span>Analysis Platform</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 3.2c-3.4 0-6.4 1.2-6.4 4.1 0 2.3.8 4.6 1.4 6.9.4 1.5.9 3.8 1.2 5.7.2 1.5.8 2.3 1.8 2.3s1.4-1.1 1.5-2.7c.2-1.7.3-2.6.5-2.6s.4.9.5 2.6c.2 1.6.5 2.7 1.5 2.7s1.6-.8 1.8-2.3c.3-1.9.8-4.2 1.2-5.7.6-2.3 1.4-4.6 1.4-6.9 0-2.9-3-4.1-6.4-4.1z"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <strong>Education</strong>
                <span>
                  <span>Smart Insights &amp;</span>
                  <span>Treatment Support</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="6.6"
                    r="3.2"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <path
                    d="M8.8 4.4h6.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M5.5 21v-3.4a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5V21"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M9.6 12.8v2.6a2.4 2.4 0 0 0 4.8 0v-2.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <circle
                    cx="16.4"
                    cy="17.4"
                    r="1.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                </svg>
                <strong>Virtual Consultation</strong>
                <span>
                  <span>2nd Opinion</span>
                  <span>Professional Care</span>
                </span>
              </div>
              <span className="lp-rail-chev" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m9 5 7 7-7 7"
                    stroke="#F472A0"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </span>
            </li>
            <li className="lp-rail-item">
              <div className="lp-rail-card">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M2.8 3.5h2.4l2.3 10.4h9.6l2.1-7.6H6.2"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <circle
                    cx="9"
                    cy="19"
                    r="1.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <circle
                    cx="16.4"
                    cy="19"
                    r="1.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                </svg>
                <strong>eMart</strong>
                <span>
                  <span>Healthier Smile</span>
                </span>
              </div>
            </li>
          </ol>
        </section>
        <section className="lp-section lp-benefits">
          <div id="for-patients" className="lp-benefit">
            <div className="lp-benefit-copy">
              <div className="lp-benefit-head">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="8"
                    cy="8.6"
                    r="2.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <circle
                    cx="15.4"
                    cy="7.4"
                    r="2.2"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <circle
                    cx="20"
                    cy="10.4"
                    r="1.7"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <path
                    d="M3 18.4a5 5 0 0 1 10 0"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M13.6 15.2a4.3 4.3 0 0 1 4.2-3.3"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <h3>Benefits for Patients</h3>
              </div>
              <ul>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Own and access your dental records</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>View 3D dental models</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Understand treatment recommendations</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Share records with dentists/orthodontists</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Track dental changes over time</span>
                </li>
              </ul>
            </div>
            <div className="lp-benefit-photo">
              <div style={{overflow: 'hidden', borderRadius: '0', position: 'absolute', inset: '0'}}>
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/benefits-patient.png"
                  alt="Patient smiling and pointing at her teeth"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center 25%',
                    display: 'block',
                  }}
                />
              </div>
              <span className="lp-benefit-feather" aria-hidden="true"></span>
            </div>
          </div>
          <div id="for-dentists" className="lp-benefit">
            <div className="lp-benefit-copy">
              <div className="lp-benefit-head">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="6.6"
                    r="3.2"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <path
                    d="M8.8 4.4h6.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M5.5 21v-3.4a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5V21"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M9.6 12.8v2.6a2.4 2.4 0 0 0 4.8 0v-2.6"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <circle
                    cx="16.4"
                    cy="17.4"
                    r="1.4"
                    stroke="#C43B71"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                </svg>
                <h3>Benefits for Dentists</h3>
              </div>
              <ul>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Patient-Created Dental History</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Stronger Patient Engagement</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Simplified Specialist Collaboration</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Easy Insurance &amp; Receipts Management</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Higher Treatment Plan Acceptance</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Easy Appointment Reminders</span>
                </li>
              </ul>
            </div>
            <div className="lp-benefit-photo">
              <div style={{overflow: 'hidden', borderRadius: '0', position: 'absolute', inset: '0'}}>
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/benefits-dentist.png"
                  alt="Dentist in a white coat in a clinic"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center 25%',
                    display: 'block',
                  }}
                />
              </div>
              <span className="lp-benefit-feather" aria-hidden="true"></span>
            </div>
          </div>
        </section>
        <a
          href="https://agapebraces.com"
          target="_blank"
          rel="noreferrer"
          style={{textDecoration: 'none', color: 'inherit', display: 'block'}}
        >
          <section id="orthodontics" className="lp-section lp-ortho">
            <div className="lp-ortho-aligner">
              <div style={{overflow: 'hidden', borderRadius: '0', position: 'absolute', inset: '0'}}>
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/ortho-aligner.jpg"
                  alt="Clear orthodontic aligner tray"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </div>
            <div className="lp-ortho-copy">
              <h2>Invisalign / Orthodontics</h2>
              <p className="lp-ortho-tag">A Better Smile with Digital Technology</p>
              <ul>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Connect digital dental records with orthodontic treatment</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>AI-assisted orthodontic screening</span>
                </li>
                <li>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="m4.5 12.5 4.5 4.5L19.5 6.5"
                      stroke="#C43B71"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Help patients find appropriate orthodontic providers</span>
                </li>
              </ul>
            </div>
            <div className="lp-ortho-logo">
              <img
                src="https://aidentalbook-poc.vercel.app/assets/invisalign-lockup.svg"
                alt="Invisalign"
                style={{height: '87px', width: 'auto', display: 'block', objectFit: 'contain'}}
              />
            </div>
            <div className="lp-ortho-smile">
              <div style={{overflow: 'hidden', borderRadius: '0', position: 'absolute', inset: '0'}}>
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/ortho-smile.png"
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </div>
          </section>
        </a>
        <section className="lp-section">
          <div className="lp-head">
            <h2 className="lp-head-title">The AIDentalBook Ecosystem</h2>
            <div className="lp-head-sub">
              <span className="lp-rule" aria-hidden="true"></span>
              <span>A Complete Solution for Modern Dental Care</span>
              <span className="lp-rule" aria-hidden="true"></span>
            </div>
          </div>
          <ul className="lp-eco">
            <li className="lp-eco-card">
              <strong>iDentalBook</strong>
              <span>Patient App</span>
              <div
                style={{overflow: 'hidden', borderRadius: '10px', position: 'relative', aspectRatio: '1.45'}}
              >
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/eco-app.jpg"
                  alt="iDentalBook patient app on a phone"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </li>
            <li className="lp-eco-card">
              <strong>AIDentalBook</strong>
              <span>AI &amp; Cloud Platform</span>
              <div
                style={{overflow: 'hidden', borderRadius: '10px', position: 'relative', aspectRatio: '1.45'}}
              >
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/eco-platform.jpg"
                  alt="AIDentalBook platform on a laptop"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </li>
            <li className="lp-eco-card">
              <strong>Dental Clinic</strong>
              <span>Clinical Care</span>
              <div
                style={{overflow: 'hidden', borderRadius: '10px', position: 'relative', aspectRatio: '1.45'}}
              >
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/eco-clinic.jpg"
                  alt="Modern dental clinic treatment room"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </li>
            <li className="lp-eco-card">
              <strong>Orthodontist</strong>
              <span>Orthodontic Treatment</span>
              <div
                style={{overflow: 'hidden', borderRadius: '10px', position: 'relative', aspectRatio: '1.45'}}
              >
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/eco-ortho.jpg"
                  alt="Patient placing a clear aligner"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </li>
            <li className="lp-eco-card">
              <strong>Invisalign</strong>
              <span>Aligner Treatment</span>
              <div
                style={{overflow: 'hidden', borderRadius: '10px', position: 'relative', aspectRatio: '1.45'}}
              >
                <img
                  src="https://aidentalbook-poc.vercel.app/assets/landing/eco-invisalign.jpg"
                  alt="Clear aligner treatment tray"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                  }}
                />
              </div>
            </li>
          </ul>
        </section>
        <section id="contact" className="lp-cta">
          <div className="lp-cta-inner">
            <div className="lp-cta-copy">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3.2c-3.4 0-6.4 1.2-6.4 4.1 0 2.3.8 4.6 1.4 6.9.4 1.5.9 3.8 1.2 5.7.2 1.5.8 2.3 1.8 2.3s1.4-1.1 1.5-2.7c.2-1.7.3-2.6.5-2.6s.4.9.5 2.6c.2 1.6.5 2.7 1.5 2.7s1.6-.8 1.8-2.3c.3-1.9.8-4.2 1.2-5.7.6-2.3 1.4-4.6 1.4-6.9 0-2.9-3-4.1-6.4-4.1z"
                  stroke="#C43B71"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <div>
                <h2>Transform Dental Care with AI</h2>
                <p>Join AIDentalBook today and experience the future of digital dental health.</p>
              </div>
            </div>
            <div className="lp-cta-actions">
              <Link className="lp-btn-primary" to="/signup">
                Join AIDentalBook
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M5 12h13M12.5 6l6 6-6 6"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <span className="lp-footer-brand">AIDentalBook</span>
          <nav className="lp-footer-links" aria-label="Footer">
            <a href="#about">About</a>
            <a href="#features">Features</a>
            <a href="#for-dentists">For Dentists</a>
            <a href="#for-patients">For Patients</a>
            <a href="#orthodontics">Orthodontics</a>
            <a href="#contact">Contact</a>
          </nav>
          <span className="lp-footer-legal">© 2026 AIDentalBook. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
